import { render } from "./goods.vue?vue&type=template&id=4e41aab2&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"

import "./goods.vue?vue&type=style&index=0&id=4e41aab2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e41aab2"]])

export default __exports__